import { render, staticRenderFns } from "./StateFactor.vue?vue&type=template&id=0ba2b6ab&"
import script from "./StateFactor.vue?vue&type=script&lang=js&"
export * from "./StateFactor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports